{
  "INBOX_MGMT": {
    "HEADER": "Căsuțe",
    "DESCRIPTION": "A channel is the mode of communication your customer chooses to interact with you. An inbox is where you manage interactions for a specific channel. It can include communications from various sources such as email, live chat, and social media.",
    "LEARN_MORE": "Learn more about inboxes",
    "COUNT": "{n} inbox | {n} inboxes",
    "SEARCH_PLACEHOLDER": "Search inboxes...",
    "NO_RESULTS": "No inboxes found matching your search",
    "RECONNECTION_REQUIRED": "Your inbox is disconnected. You won't receive new messages until you reauthorize it.",
    "CLICK_TO_RECONNECT": "Click here to reconnect.",
    "WHATSAPP_REGISTRATION_INCOMPLETE": "Your WhatsApp Business registration isn’t complete. Please check your display name status in Meta Business Manager before reconnecting.",
    "COMPLETE_REGISTRATION": "Complete Registration",
    "LIST": {
      "404": "Nu există căsuțe poștale atașate acestui cont."
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Alege canalul",
        "BODY": "Alegeți serviciul pe care doriți să-l integrați cu Chatwoot."
      },
      "INBOX": {
        "TITLE": "Crează căsuța",
        "BODY": "Autentifică-te cu contul tău și creează un inbox."
      },
      "AGENT": {
        "TITLE": "Adaugă Agent",
        "BODY": "Adaugă agenți la inbox-ul creat."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "Toate setarile sunt facute!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Nume Inbox",
        "PLACEHOLDER": "Introduceți numele inboxului (de exemplu: Acme Inc)",
        "ERROR": "Vă rugăm să introduceți un nume valid de inbox"
      },
      "WEBSITE_NAME": {
        "LABEL": "Nume website",
        "PLACEHOLDER": "Introduceți numele website-ului dvs. (de exemplu: Acme Inc)"
      },
      "FB": {
        "HELP": "PS: Prin conectare, vom avea acces doar la mesajele paginii tale. Mesajele tale private nu pot fi accesate niciodată de Chatwoot.",
        "CHOOSE_PAGE": "Alege pagina",
        "CHOOSE_PLACEHOLDER": "Selectaţi o pagină din listă",
        "INBOX_NAME": "Nume Inbox",
        "ADD_NAME": "Adaugă un nume pentru inbox-ul tău",
        "PICK_NAME": "Pick a Name for your Inbox",
        "PICK_A_VALUE": "Alege o valoare",
        "CREATE_INBOX": "Crează căsuța"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Continue with Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Connect your Instagram Profile",
        "HELP": "To add your Instagram profile as a channel, you need to authenticate your Instagram Profile by clicking on 'Continue with Instagram' ",
        "ERROR_MESSAGE": "There was an error connecting to Instagram, please try again",
        "ERROR_AUTH": "There was an error connecting to Instagram, please try again",
        "NEW_INBOX_SUGGESTION": "This Instagram account was previously linked to a different inbox and has now been migrated here. All new messages will appear here. The old inbox will no longer be able to send or receive messages for this account.",
        "DUPLICATE_INBOX_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. You won’t be able to send/receive Instagram messages from this inbox anymore.",
        "SETTINGS_RESTRICTED_WARNING": "Instagram is currently restricted. Some messages or actions may be delayed or unavailable while we restore full support.",
        "STATUS_LINK": "View status update"
      },
      "TIKTOK": {
        "CONTINUE_WITH_TIKTOK": "Continue with TikTok",
        "CONNECT_YOUR_TIKTOK_PROFILE": "Connect your TikTok Profile",
        "HELP": "To add your TikTok profile as a channel, you need to authenticate your TikTok Profile by clicking on 'Continue with TikTok' ",
        "ERROR_MESSAGE": "There was an error connecting to TikTok, please try again",
        "ERROR_AUTH": "There was an error connecting to TikTok, please try again",
        "NORTH_AMERICA_WARNING": "TikTok connections for North American accounts are temporarily unavailable while we wait for an update from the TikTok team."
      },
      "TWITTER": {
        "HELP": "Pentru a vă adăuga profilul de Twitter ca si canal, trebuie să vă autentificați profilul de Twitter făcând clic pe \"Conectați-vă cu Twitter\" ",
        "ERROR_MESSAGE": "A existat o eroare de conectare la Twitter, vă rugăm să încercați din nou",
        "TWEETS": {
          "ENABLE": "Creați conversații din tweet-urile menționate"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Canal web",
        "DESC": "Creați un canal pentru site-ul dvs. și începeți să asigurati suportul clienților prin intermediul widget-ului nostru web.",
        "LOADING_MESSAGE": "Crearea canalului de suport pe site",
        "CHANNEL_AVATAR": {
          "LABEL": "Avatar canal"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "URL Webhook",
          "PLACEHOLDER": "Please enter your Webhook URL",
          "ERROR": "Te rog introdu un URL valid"
        },
        "CHANNEL_WEBHOOK_SECRET": {
          "LABEL": "Webhook Secret",
          "COPY": "Copy secret to clipboard",
          "COPY_SUCCESS": "Secret copied to clipboard",
          "TOGGLE": "Toggle secret visibility",
          "RESET_SUCCESS": "Webhook secret regenerated successfully",
          "RESET_ERROR": "Unable to regenerate webhook secret. Please try again"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Domeniu website",
          "PLACEHOLDER": "Introduceți domeniul website-ului (exemplu: acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Titlu de salut",
          "PLACEHOLDER": "Salut!"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Tagline de Bun Venit",
          "PLACEHOLDER": "Noi facem conectarea cu noi simplă. Întreabă-ne orice, sau partajează-ți feedback-ul."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Mesaj de întâmpinare canal",
          "PLACEHOLDER": "De obicei, Acme Inc răspunde în câteva ore."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Activare salut canal",
          "HELP_TEXT": "Trimiteți automat mesaje de întâmpinare atunci când clienții încep o conversație și trimit primul lor mesaj.",
          "ENABLED": "Activat",
          "DISABLED": "Dezactivat"
        },
        "REPLY_TIME": {
          "TITLE": "Setarea orei de răspuns",
          "IN_A_FEW_MINUTES": "În câteva minute",
          "IN_A_FEW_HOURS": "În câteva ore",
          "IN_A_DAY": "Într-o zi",
          "HELP_TEXT": "Acest timp de răspuns va fi afișat pe widget-ul de chat live"
        },
        "WIDGET_COLOR": {
          "LABEL": "Culoare widget",
          "PLACEHOLDER": "Actualizează culoarea folosită în widget"
        },
        "SUBMIT_BUTTON": "Crează inbox",
        "API": {
          "ERROR_MESSAGE": "Nu am reușit să creăm un canal de site web, vă rugăm să încercați din nou"
        }
      },
      "TWILIO": {
        "TITLE": "Twilio SMS/Canal WhatsApp",
        "DESC": "Integrați Twilio și începeți să vă sprijiniți clienții prin SMS sau WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "Cont SID",
          "PLACEHOLDER": "Te rugăm să introduci ID-ul contului Twilio",
          "ERROR": "Acest câmp este obligatoriu"
        },
        "API_KEY": {
          "USE_API_KEY": "Use API Key Authentication",
          "LABEL": "API Key SID",
          "PLACEHOLDER": "Please enter your API Key SID",
          "ERROR": "Acest câmp este obligatoriu"
        },
        "API_KEY_SECRET": {
          "LABEL": "API Key Secret",
          "PLACEHOLDER": "Please enter your API Key Secret",
          "ERROR": "Acest câmp este obligatoriu"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "Serviciul de mesagerie SID",
          "PLACEHOLDER": "Vă rugăm să introduceți Twilio Messaging Service SID",
          "ERROR": "Acest câmp este obligatoriu",
          "USE_MESSAGING_SERVICE": "Utilizați un serviciu de mesagerie Twilio"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Tipul canalului",
          "ERROR": "Vă rugăm să selectaţi tipul canalului"
        },
        "AUTH_TOKEN": {
          "LABEL": "Token de autentificare",
          "PLACEHOLDER": "Te rugăm să introduci tokenul Twilio Auth",
          "ERROR": "Acest câmp este obligatoriu"
        },
        "CHANNEL_NAME": {
          "LABEL": "Nume Inbox",
          "PLACEHOLDER": "Vă rugăm să introduceți un nume de inbox",
          "ERROR": "Acest câmp este obligatoriu"
        },
        "PHONE_NUMBER": {
          "LABEL": "Număr de telefon",
          "PLACEHOLDER": "Introduceți numărul de telefon de la care va fi trimis mesajul.",
          "ERROR": "Vă rugăm să furnizați un număr de telefon valid care începe cu semnul \"+\" și nu conține spații."
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "Trebuie să configurați URL-ul de callback al mesajelor în Twilio cu adresa URL menționată aici."
        },
        "SUBMIT_BUTTON": "Crează canal Twilio",
        "API": {
          "ERROR_MESSAGE": "Nu am putut autentifica credentialele Twilio, încercați din nou"
        }
      },
      "SMS": {
        "TITLE": "Canal SMS",
        "DESC": "Începeți să vă sprijiniți clienții prin SMS.",
        "PROVIDERS": {
          "LABEL": "Furnizor API",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Banda"
        },
        "API": {
          "ERROR_MESSAGE": "Nu am reușit să salvăm canalul SMS"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "ID cont",
            "PLACEHOLDER": "Vă rugăm să introduceți ID-ul contului de lățime de bandă",
            "ERROR": "Acest câmp este obligatoriu"
          },
          "API_KEY": {
            "LABEL": "Cheie API",
            "PLACEHOLDER": "Please enter your Bandwidth API Key",
            "ERROR": "Acest câmp este obligatoriu"
          },
          "API_SECRET": {
            "LABEL": "API secret",
            "PLACEHOLDER": "Please enter your Bandwidth API Secret",
            "ERROR": "Acest câmp este obligatoriu"
          },
          "APPLICATION_ID": {
            "LABEL": "ID Aplicaţie",
            "PLACEHOLDER": "Vă rugăm să introduceți ID-ul aplicației lățimea de bandă",
            "ERROR": "Acest câmp este obligatoriu"
          },
          "INBOX_NAME": {
            "LABEL": "Nume Inbox",
            "PLACEHOLDER": "Vă rugăm să introduceți un nume de inbox",
            "ERROR": "Acest câmp este obligatoriu"
          },
          "PHONE_NUMBER": {
            "LABEL": "Număr de telefon",
            "PLACEHOLDER": "Introduceți numărul de telefon de la care va fi trimis mesajul.",
            "ERROR": "Vă rugăm să furnizați un număr de telefon valid care începe cu semnul \"+\" și nu conține spații."
          },
          "SUBMIT_BUTTON": "Creați un canal de lățime de bandă",
          "API": {
            "ERROR_MESSAGE": "Nu am reușit să autentificăm acreditările de lățime de bandă, vă rugăm să încercați din nou"
          },
          "API_CALLBACK": {
            "TITLE": "Callback URL",
            "SUBTITLE": "Trebuie să configurați URL-ul de apelare inversă a mesajului în Lățime de bandă cu URL-ul menționat aici."
          }
        }
      },
      "WHATSAPP": {
        "TITLE": "Canalul WhatsApp",
        "DESC": "Începeți să vă sprijiniți clienții prin WhatsApp.",
        "PROVIDERS": {
          "LABEL": "Furnizor API",
          "WHATSAPP_EMBEDDED": "WhatsApp Business",
          "TWILIO": "Twilio",
          "WHATSAPP_CLOUD": "WhatsApp Cloud",
          "WHATSAPP_CLOUD_DESC": "Quick setup through Meta",
          "TWILIO_DESC": "Connect via Twilio credentials",
          "360_DIALOG": "360Dialog"
        },
        "SELECT_PROVIDER": {
          "TITLE": "Select your API provider",
          "DESCRIPTION": "Choose your WhatsApp provider. You can connect directly through Meta which requires no setup, or connect through Twilio using your account credentials."
        },
        "INBOX_NAME": {
          "LABEL": "Nume Inbox",
          "PLACEHOLDER": "Vă rugăm să introduceți un nume de inbox",
          "ERROR": "Acest câmp este obligatoriu"
        },
        "PHONE_NUMBER": {
          "LABEL": "Număr de telefon",
          "PLACEHOLDER": "Introduceți numărul de telefon de la care va fi trimis mesajul.",
          "ERROR": "Vă rugăm să furnizați un număr de telefon valid care începe cu semnul \"+\" și nu conține spații."
        },
        "PHONE_NUMBER_ID": {
          "LABEL": "ID-ul numărului de telefon",
          "PLACEHOLDER": "Te rugăm să introduci ID-ul numărului de telefon obținut din tabloul de bord al dezvoltatorului Facebook.",
          "ERROR": "Vă rugăm să introduceți o valoare validă."
        },
        "BUSINESS_ACCOUNT_ID": {
          "LABEL": "ID-ul contului de companie",
          "PLACEHOLDER": "Te rugăm să introduci ID-ul contului de companie obținut din tabloul de bord al dezvoltatorului Facebook.",
          "ERROR": "Vă rugăm să introduceți o valoare validă."
        },
        "WEBHOOK_VERIFY_TOKEN": {
          "LABEL": "Webhook Verifica token-ul",
          "PLACEHOLDER": "Enter a verify token which you want to configure for Facebook webhooks.",
          "ERROR": "Vă rugăm să introduceți o valoare validă."
        },
        "API_KEY": {
          "LABEL": "Cheie API",
          "SUBTITLE": "Configurați cheia API WhatsApp.",
          "PLACEHOLDER": "Cheie API",
          "ERROR": "Vă rugăm să introduceți o valoare validă."
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "Trebuie să configurezi adresa URL webhook și simbolul de verificare în portalul Facebook pentru dezvoltatori cu valorile afișate mai jos.",
          "WEBHOOK_URL": "URL Webhook",
          "WEBHOOK_VERIFICATION_TOKEN": "Token de verificare Webhook"
        },
        "SUBMIT_BUTTON": "Creați canalul WhatsApp",
        "EMBEDDED_SIGNUP": {
          "TITLE": "Quick setup with Meta",
          "DESC": "Use the WhatsApp Embedded Signup flow to quickly connect new numbers. You will be redirected to Meta to log into your WhatsApp Business account. Having admin access will help make the setup smooth and easy.",
          "BENEFITS": {
            "TITLE": "Benefits of Embedded Signup:",
            "EASY_SETUP": "No manual configuration required",
            "SECURE_AUTH": "Secure OAuth based authentication",
            "AUTO_CONFIG": "Automatic webhook and phone number configuration"
          },
          "LEARN_MORE": {
            "TEXT": "To learn more about integrated signup, pricing, and limitations, visit {link}.",
            "LINK_TEXT": "this link"
          },
          "SUBMIT_BUTTON": "Connect with WhatsApp Business",
          "AUTH_PROCESSING": "Authenticating with Meta",
          "WAITING_FOR_BUSINESS_INFO": "Please complete business setup in the Meta window...",
          "PROCESSING": "Setting up your WhatsApp Business Account",
          "ENABLING_CALLING": "Enabling WhatsApp Calling on your number…",
          "LOADING_SDK": "Loading Facebook SDK...",
          "CANCELLED": "WhatsApp Signup was cancelled",
          "SUCCESS_TITLE": "WhatsApp Business Account Connected!",
          "WAITING_FOR_AUTH": "Waiting for authentication...",
          "INVALID_BUSINESS_DATA": "Invalid business data received from Facebook. Please try again.",
          "SIGNUP_ERROR": "Signup error occurred",
          "AUTH_NOT_COMPLETED": "Authentication not completed. Please restart the process.",
          "SUCCESS_FALLBACK": "WhatsApp Business Account has been successfully configured",
          "MANUAL_FALLBACK": "If your number is already connected to the WhatsApp Business Platform (API), or if you’re a tech provider onboarding your own number, please use the {link} flow",
          "MANUAL_LINK_TEXT": "manual setup flow",
          "CALLING_ENABLE_FAILED": "Your WhatsApp inbox is ready, but voice calling couldn't be turned on — this number isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then turn calling on from the inbox's Calls settings."
        },
        "API": {
          "ERROR_MESSAGE": "Nu am reușit să salvăm canalul WhatsApp"
        }
      },
      "VOICE": {
        "TITLE": "Voice Channel",
        "DESC": "Integrate Twilio Voice and start supporting your customers via phone calls.",
        "PHONE_NUMBER": {
          "LABEL": "Număr de telefon",
          "PLACEHOLDER": "Enter your phone number (e.g. +1234567890)",
          "ERROR": "Please provide a valid phone number in E.164 format (e.g. +1234567890)"
        },
        "TWILIO": {
          "ACCOUNT_SID": {
            "LABEL": "Cont SID",
            "PLACEHOLDER": "Enter your Twilio Account SID",
            "REQUIRED": "Account SID is required"
          },
          "AUTH_TOKEN": {
            "LABEL": "Token de autentificare",
            "PLACEHOLDER": "Enter your Twilio Auth Token",
            "REQUIRED": "Auth Token is required"
          },
          "API_KEY_SID": {
            "LABEL": "API Key SID",
            "PLACEHOLDER": "Enter your Twilio API Key SID",
            "REQUIRED": "API Key SID is required"
          },
          "API_KEY_SECRET": {
            "LABEL": "API Key Secret",
            "PLACEHOLDER": "Enter your Twilio API Key Secret",
            "REQUIRED": "API Key Secret is required"
          }
        },
        "CONFIGURATION": {
          "TWILIO_VOICE_URL_TITLE": "Twilio Voice URL",
          "TWILIO_VOICE_URL_SUBTITLE": "Configure this URL as the Voice URL on your Twilio phone number and TwiML App.",
          "TWILIO_STATUS_URL_TITLE": "Twilio Status Callback URL",
          "TWILIO_STATUS_URL_SUBTITLE": "Configure this URL as the Status Callback URL on your Twilio phone number."
        },
        "SUBMIT_BUTTON": "Create Voice Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to create the voice channel"
        }
      },
      "API_CHANNEL": {
        "TITLE": "Canal API",
        "DESC": "Integrați-vă cu canalul API și începeți să vă sprijiniți clienții.",
        "CHANNEL_NAME": {
          "LABEL": "Nume canal",
          "PLACEHOLDER": "Te rugăm să introduci un conținut",
          "ERROR": "Acest câmp este obligatoriu"
        },
        "WEBHOOK_URL": {
          "LABEL": "URL Webhook",
          "SUBTITLE": "Configure the URL where you want to receive callbacks on events.",
          "PLACEHOLDER": "URL Webhook"
        },
        "SUBMIT_BUTTON": "Creare canal API",
        "API": {
          "ERROR_MESSAGE": "Nu am putut salva canalul API"
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "Canal de e-mail",
        "DESC": "Integrate your email inbox.",
        "CHANNEL_NAME": {
          "LABEL": "Nume canal",
          "PLACEHOLDER": "Te rugăm să introduci un conținut",
          "ERROR": "Acest câmp este obligatoriu"
        },
        "EMAIL": {
          "LABEL": "Email",
          "SUBTITLE": "Furnizați adresa de e-mail la care clienții trimit solicitări de asistență.",
          "PLACEHOLDER": "Email"
        },
        "SUBMIT_BUTTON": "Creare canal Email",
        "API": {
          "ERROR_MESSAGE": "Nu am putut salva canalul de email"
        },
        "FINISH_MESSAGE": "Începeți să vă trimiteți e-mailuri la următoarea adresă de e-mail.",
        "FINISH_MESSAGE_NO_FORWARDING": "Your email inbox has been created successfully! You need to configure SMTP and IMAP credentials to send and receive emails. Without these settings, no emails will be processed.",
        "FORWARDING_ADDRESS_LABEL": "Forward emails to this address:",
        "CONFIGURE_SMTP_IMAP_LINK": "Click aici",
        "CONFIGURE_SMTP_IMAP_TEXT": " to configure IMAP and SMTP settings"
      },
      "LINE_CHANNEL": {
        "TITLE": "Canal LINE",
        "DESC": "Integrați-vă cu canalul LINE și începeți să vă sprijiniți clienții.",
        "CHANNEL_NAME": {
          "LABEL": "Nume canal",
          "PLACEHOLDER": "Te rugăm să introduci un conținut",
          "ERROR": "Acest câmp este obligatoriu"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "ID-ul canalului LINE",
          "PLACEHOLDER": "ID-ul canalului LINE"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "Secret canal LINE",
          "PLACEHOLDER": "Secret canal LINE"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "Token canal LINE",
          "PLACEHOLDER": "Token canal LINE"
        },
        "SUBMIT_BUTTON": "Crearea canalului LINE",
        "API": {
          "ERROR_MESSAGE": "Nu am reușit să salvăm canalul LINE"
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "Trebuie să configurați URL-ul webhook în aplicația LINE cu URL-ul menționat aici."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Canal Telegram",
        "DESC": "Integrați-vă cu canalul Telegram și începeți să vă sprijiniți clienții.",
        "BOT_TOKEN": {
          "LABEL": "Token de bot",
          "SUBTITLE": "Configurați simbolul bot pe care l-ați obținut de la Telegram BotFather.",
          "PLACEHOLDER": "Token de bot"
        },
        "SUBMIT_BUTTON": "Creați canal Telegram",
        "API": {
          "ERROR_MESSAGE": "Nu am reușit să salvăm canalul de telegramă"
        }
      },
      "AUTH": {
        "TITLE": "Alege un canal",
        "DESC": "Chatwoot acceptă widget-uri live-chat, Facebook Messenger, profiluri Twitter, WhatsApp, e-mailuri etc., ca canale. Dacă doriți să construiți un canal personalizat, îl puteți crea folosind canalul API. Pentru a începe, alegeți unul dintre canalele de mai jos.",
        "TITLE_NEXT": "Complete the setup",
        "TITLE_FINISH": "Voilà!",
        "CHANNEL": {
          "WEBSITE": {
            "TITLE": "Website",
            "DESCRIPTION": "Create a live-chat widget"
          },
          "FACEBOOK": {
            "TITLE": "Facebook",
            "DESCRIPTION": "Connect your Facebook page"
          },
          "WHATSAPP": {
            "TITLE": "WhatsApp",
            "DESCRIPTION": "Support your customers on WhatsApp"
          },
          "WHATSAPP_CALL": {
            "TITLE": "WhatsApp Call",
            "DESCRIPTION": "Take voice calls on your WhatsApp number"
          },
          "EMAIL": {
            "TITLE": "E-mail",
            "DESCRIPTION": "Connect with Gmail, Outlook, or other providers"
          },
          "SMS": {
            "TITLE": "SMS",
            "DESCRIPTION": "Integrate SMS channel with Twilio or bandwidth"
          },
          "API": {
            "TITLE": "API",
            "DESCRIPTION": "Make a custom channel using our API"
          },
          "TELEGRAM": {
            "TITLE": "Telegram",
            "DESCRIPTION": "Configure Telegram channel using Bot token"
          },
          "LINE": {
            "TITLE": "Line",
            "DESCRIPTION": "Integrate your Line channel"
          },
          "INSTAGRAM": {
            "TITLE": "Instagram",
            "DESCRIPTION": "Connect your instagram account"
          },
          "TIKTOK": {
            "TITLE": "TikTok",
            "DESCRIPTION": "Connect your TikTok account"
          },
          "VOICE": {
            "TITLE": "Voice",
            "DESCRIPTION": "Integrate with Twilio Voice"
          }
        }
      },
      "AGENTS": {
        "TITLE": "Agenți",
        "DESC": "Aici puteți adăuga agenți care să gestioneze inboxul nou creat. Numai acești agenți selectați vor avea acces la căsuța poștală. Agenții care nu fac parte din această căsuță poștală nu vor putea vedea sau răspunde la mesajele din această căsuță atunci când se autentifică. <br> <b>PS:</b> În calitate de administrator, dacă aveţi nevoie de acces la toate mesajele, ar trebui să vă adăugați ca agent la toate cutiile de mesaje pe care le creați.",
        "VALIDATION_ERROR": "Add at least one agent to your new Inbox",
        "PICK_AGENTS": "Alegerea agenților pentru inbox"
      },
      "DETAILS": {
        "TITLE": "Detalii inbox",
        "DESC": "Din meniul derulant de mai jos, selectați pagina Facebook pe care doriți să vă conectați la Chatwoot. Poți de asemenea să dai un nume personalizat inbox-ului pentru o mai bună identificare."
      },
      "FINISH": {
        "TITLE": "Corect!",
        "DESC": "Ai reușit să integrezi pagina ta de Facebook cu Chatwoot. Data viitoare când un client trimite un mesaj paginii tale, conversația va apărea automat pe căsuța ta poștală.<br>Vă oferim și un script de widget pe care îl puteți adăuga cu ușurință la site-ul dvs. Odată ce aceasta este în direct pe site-ul tău, clienții vă pot trimite mesaje direct de pe site-ul dvs fără ajutorul niciunui instrument extern și conversația va apărea aici, pe Chatwoot.<br>Cool, nu? Păi, sigur că încercăm să fim :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Selectați furnizorul de e-mail",
        "DESCRIPTION": "Selectați un furnizor de e-mail din lista de mai jos. Dacă nu vedeți furnizorul de e-mail în listă, puteți selecta opțiunea celuilalt furnizor și furniza acreditările IMAP și SMTP."
      },
      "MICROSOFT": {
        "TITLE": "E-mail Microsoft",
        "DESCRIPTION": "Faceți clic pe butonul Conectare cu Microsoft pentru a începe. Veți redirecționa către pagina de conectare la e-mail. După ce acceptați permisiunile solicitate, veți fi redirecționat înapoi la pasul de creare a inboxului.",
        "EMAIL_PLACEHOLDER": "Introdu adresa de e-mail",
        "SIGN_IN": "Sign in with Microsoft",
        "ERROR_MESSAGE": "A existat o eroare la conectarea la Microsoft, încercați din nou"
      },
      "GOOGLE": {
        "TITLE": "Google Email",
        "DESCRIPTION": "Click on the Sign in with Google button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "SIGN_IN": "Sign in with Google",
        "EMAIL_PLACEHOLDER": "Introdu adresa de e-mail",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Autentificare prin Facebook...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "Ceva nu a mers bine, reîmprospătați pagina...",
      "ERROR_FB_UNAUTHORIZED": "You're not authorized to perform this action. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Please ensure you have access to the Facebook page with full control. You can read more about Facebook roles <a href=\" https://www.facebook.com/help/187316341316631\">here</a>.",
      "CREATING_CHANNEL": "Se creează inbox...",
      "TITLE": "Configurare detalii inbox",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Adaugă Agent",
      "ADD_AGENTS": "Adăugare agenți la inbox-ul dumneavoastra..."
    },
    "FINISH": {
      "TITLE": "Inbox-ul este gata!",
      "MESSAGE": "Acum poți intra în contact cu clienții tăi prin noul tău Canal. Suport fericit",
      "BUTTON_TEXT": "Du-mă acolo",
      "MORE_SETTINGS": "Mai multe setări",
      "WEBSITE_SUCCESS": "Ați finalizat cu succes crearea unui canal web. Copiați codul de mai jos și inserati-l pe site-ul dvs. Data viitoare când un client folosește conversația live, conversația va apărea automat pe căsuța poștală.",
      "WHATSAPP_QR_INSTRUCTION": "Scan the QR code above to quickly test your WhatsApp inbox",
      "MESSENGER_QR_INSTRUCTION": "Scan the QR code above to quickly test your Facebook Messenger inbox",
      "TELEGRAM_QR_INSTRUCTION": "Scan the QR code above to quickly test your Telegram inbox"
    },
    "REAUTH": "Reautorizează",
    "VIEW": "Vizualizare",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Setări Inbox actualizate cu succes",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Atribuire automată actualizată cu succes",
        "ERROR_MESSAGE": "Nu am putut actualiza setările inboxului. Încercați din nou mai târziu."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Activat",
        "DISABLED": "Dezactivat"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Activat",
        "DISABLED": "Dezactivat"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Sender name",
        "SUB_TEXT": "Select the name shown to your customer when they receive emails from your agents.",
        "FOR_EG": "For eg:",
        "FRIENDLY": {
          "TITLE": "Amical",
          "FROM": "de la",
          "SUBTITLE": "Add the name of the agent who sent the reply in the sender name to make it friendly."
        },
        "PROFESSIONAL": {
          "TITLE": "Profesională",
          "SUBTITLE": "Use only the configured business name as the sender name in the email header."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "Configure your business name",
          "PLACEHOLDER": "Enter your business name",
          "SAVE_BUTTON_TEXT": "Salvează"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Activat",
        "DISABLED": "Dezactivat"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Activat",
        "DISABLED": "Dezactivat"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Reopen same conversation",
        "DISABLED": "Create new conversations",
        "ENABLED_DESCRIPTION": "When a contact messages again, the previous conversation will be reopened.",
        "DISABLED_DESCRIPTION": "A new conversation will be created each time after the previous one is resolved."
      },
      "ENABLE_HMAC": {
        "LABEL": "Permite"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Şterge",
      "AVATAR_DELETE_BUTTON_TEXT": "Șterge avatarul",
      "CONFIRM": {
        "TITLE": "Confirmă ștergerea",
        "MESSAGE": "Sigur doriți să ștergeți ",
        "PLACE_HOLDER": "Vă rugăm să tastați {inboxName} pentru a confirma",
        "YES": "Da, șterge ",
        "NO": "Nu, păstreaza "
      },
      "API": {
        "SUCCESS_MESSAGE": "Inbox șters cu succes",
        "ERROR_MESSAGE": "Nu s-a putut șterge inbox-ul. Vă rugăm să încercați din nou mai târziu.",
        "AVATAR_SUCCESS_MESSAGE": "Avatar inbox șters cu succes",
        "AVATAR_ERROR_MESSAGE": "Nu s-a putut șterge avatarul inboxului. Încercați din nou mai târziu."
      }
    },
    "TABS": {
      "SETTINGS": "Setări",
      "COLLABORATORS": "Colaboratori",
      "CONFIGURATION": "Configurare",
      "CAMPAIGN": "Campanii",
      "PRE_CHAT_FORM": "Formular pre chat",
      "BUSINESS_HOURS": "Program de lucru",
      "WIDGET_BUILDER": "Widget Builder",
      "BOT_CONFIGURATION": "Configurarea botului",
      "ACCOUNT_HEALTH": "Account Health",
      "CSAT": "CSAT",
      "VOICE": "Voice",
      "CALLS": "Calls"
    },
    "VOICE_CONFIGURATION": {
      "ENABLE_VOICE": {
        "LABEL": "Enable Voice Calling",
        "DESCRIPTION": "Enable voice calling on this inbox. Agents will be able to make and receive phone calls."
      },
      "CREDENTIALS": {
        "DESCRIPTION": "Voice calling requires Twilio API Key credentials. These are used to generate tokens for agent voice connections."
      },
      "INBOUND": {
        "LABEL": "Allow incoming calls",
        "DESCRIPTION": "Let customers call this number. When turned off, incoming calls are declined automatically — agents aren't notified and no conversation is created. Agents can still place outgoing calls."
      }
    },
    "WHATSAPP_CALLING": {
      "ENABLE": {
        "LABEL": "Enable WhatsApp Calling",
        "DESCRIPTION": "Allow agents to receive and place WhatsApp Cloud calls on this inbox. Customers can call this business number directly from WhatsApp."
      },
      "ENABLE_FAILED": "Voice calling couldn't be turned on for this number — it isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then try again.",
      "PHONE_NUMBER": {
        "LABEL": "Business phone number",
        "HELP_TEXT": "WhatsApp number that customers will call."
      },
      "HOW_IT_WORKS": {
        "LABEL": "How it works",
        "DESCRIPTION": "Calls are placed peer-to-peer between the agent's browser and Meta — no extra credentials are required. Make sure the agent's browser has microphone permission for this site."
      },
      "PERMISSION_REQUEST_BODY": {
        "LABEL": "Call permission request message",
        "HELP_TEXT": "Shown to the contact when they haven't yet consented to receive calls. Leave blank to use the default.",
        "PLACEHOLDER": "We would like to call you regarding your conversation."
      }
    },
    "CHANNEL_PREFERENCES": "Channel Preferences",
    "WIDGET_FEATURES": "Widget features",
    "ACCOUNT_HEALTH": {
      "TITLE": "Manage your WhatsApp account",
      "DESCRIPTION": "Review your WhatsApp account status, messaging limits, and quality. Update settings or resolve issues if needed",
      "GO_TO_SETTINGS": "Go to Meta Business Manager",
      "NO_DATA": "Health data is not available",
      "FIELDS": {
        "DISPLAY_PHONE_NUMBER": {
          "LABEL": "Display phone number",
          "TOOLTIP": "Phone number displayed to customers"
        },
        "VERIFIED_NAME": {
          "LABEL": "Business name",
          "TOOLTIP": "Business name verified by WhatsApp"
        },
        "DISPLAY_NAME_STATUS": {
          "LABEL": "Display name status",
          "TOOLTIP": "Status of your business name verification"
        },
        "QUALITY_RATING": {
          "LABEL": "Quality rating",
          "TOOLTIP": "WhatsApp quality rating for your account"
        },
        "MESSAGING_LIMIT_TIER": {
          "LABEL": "Messaging limit tier",
          "TOOLTIP": "Daily messaging limit for your account"
        },
        "ACCOUNT_MODE": {
          "LABEL": "Account mode",
          "TOOLTIP": "Current operating mode of your WhatsApp account"
        }
      },
      "VALUES": {
        "TIERS": {
          "TIER_250": "250 customers per 24h",
          "TIER_1000": "1K customers per 24h",
          "TIER_1K": "1K customers per 24h",
          "TIER_10K": "10K customers per 24h",
          "TIER_100K": "100K customers per 24h",
          "TIER_UNLIMITED": "Unlimited customers per 24h",
          "UNKNOWN": "Rating not available"
        },
        "STATUSES": {
          "APPROVED": "Approved",
          "PENDING_REVIEW": "Pending Review",
          "AVAILABLE_WITHOUT_REVIEW": "Available Without Review",
          "REJECTED": "Rejected",
          "DECLINED": "Declined",
          "NON_EXISTS": "Non exists"
        },
        "MODES": {
          "SANDBOX": "Sandbox",
          "LIVE": "Live"
        }
      },
      "WEBHOOK": {
        "TITLE": "Webhook Configuration",
        "DESCRIPTION": "Webhook URL is required for your WhatsApp Business Account to receive messages from customers",
        "ACTION_REQUIRED": "Webhook not configured",
        "REGISTER_BUTTON": "Register Webhook",
        "REGISTER_SUCCESS": "Webhook registered successfully",
        "REGISTER_ERROR": "Failed to register webhook. Please try again.",
        "CONFIGURED_SUCCESS": "Webhook configured successfully",
        "URL_MISMATCH": "Webhook URL mismatch"
      }
    },
    "SETTINGS": "Setări",
    "FEATURES": {
      "LABEL": "Caracteristici",
      "DISPLAY_FILE_PICKER": "Afișarea selectorului de fișiere pe widget",
      "DISPLAY_EMOJI_PICKER": "Afișarea selectorului de emoji pe widget",
      "ALLOW_END_CONVERSATION": "Permite utilizatorilor să încheie conversația din widget",
      "USE_INBOX_AVATAR_FOR_BOT": "Utilizați numele inboxului și avatarul pentru bot"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Script Messenger",
      "MESSENGER_SUB_HEAD": "Plasează acest buton în interiorul interiorul paginii web",
      "ALLOWED_DOMAINS": {
        "TITLE": "Allowed Domains",
        "DESCRIPTION": "Restrict which websites can embed your chat widget. For security, only add domains you own and trust. Add one or more domains separated by commas. Leave blank to allow all domains (not recommended for production).",
        "PLACEHOLDER": "example.com, www.example.com, app.example.com"
      },
      "ALLOW_MOBILE_WEBVIEW": {
        "LABEL": "Enable widget in mobile apps",
        "SUBTITLE": "Check this if you embed the widget in iOS or Android apps. Mobile apps don't send domain information, so they would be blocked by domain restrictions unless this is enabled."
      },
      "IDENTITY_VALIDATION": {
        "TITLE": "Identity Validation",
        "DESCRIPTION": "Verify user authenticity by generating secure tokens. This prevents unauthorized users from impersonating others in your chat.",
        "SECRET_KEY": "Secret Key",
        "VIEW_DOCS": "View documentation",
        "REQUIRE_LABEL": "Require identity validation for all conversations",
        "REQUIRE_DESCRIPTION": "When enabled, users must provide a valid identity token to start conversations. Requests without valid tokens will be rejected."
      },
      "INBOX_AGENTS": "Agenți",
      "INBOX_AGENTS_SUB_TEXT": "Adaugă sau elimină agenți din acest inbox",
      "AGENT_ASSIGNMENT": "Atribuirea conversației",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Actualizarea setărilor de atribuire a conversațiilor",
      "UPDATE": "Actualizare",
      "ENABLE_EMAIL_COLLECT_BOX": "Caseta Activare colectare e-mail",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Caseta Activarea sau dezactivarea colectării e-mailurilor în conversația nouă",
      "AUTO_ASSIGNMENT": "Activare atribuire automată",
      "SENDER_NAME_SECTION": "Enable Agent Name in Email",
      "SENDER_NAME_SECTION_TEXT": "Enable/Disable showing Agent's name in email, if disabled it will show business name",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Activați continuitatea conversației prin e-mail",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Conversațiile vor continua prin e-mail dacă adresa de e-mail de contact este disponibilă.",
      "ENABLE_CONTINUITY_VIA_EMAIL_DISABLED_TEXT": "This feature is available on a paid plan. Upgrade to enable conversation continuity via email.",
      "LOCK_TO_SINGLE_CONVERSATION": "Conversation Routing",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Configure conversation creation for existing contacts",
      "INBOX_UPDATE_TITLE": "Setări Inbox",
      "INBOX_UPDATE_SUB_TEXT": "Actualizează setările de inbox",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Activează sau dezactivează atribuirea automată a conversațiilor noi la agenții adăugați la această căsuță poștală.",
      "HMAC_VERIFICATION": "Validarea identității utilizatorului",
      "HMAC_DESCRIPTION": "Cu această cheie puteți genera un token secret care poate fi utilizat pentru a verifica identitatea utilizatorilor dvs.",
      "HMAC_LINK_TO_DOCS": "Puteți citi mai multe aici.",
      "HMAC_MANDATORY_VERIFICATION": "Impuneți validarea identității utilizatorului",
      "HMAC_MANDATORY_DESCRIPTION": "Dacă este activată, solicitările care nu pot fi verificate vor fi respinse.",
      "INBOX_IDENTIFIER": "Identificator inbox",
      "INBOX_IDENTIFIER_SUB_TEXT": "Utilizați simbolul \"inbox_identifier\" afișat aici pentru a vă autentifica clienții API.",
      "FORWARD_EMAIL_TITLE": "Redirecționare către e-mail",
      "FORWARD_EMAIL_SUB_TEXT": "Începeți să vă trimiteți e-mailuri la următoarea adresă de e-mail.",
      "FORWARD_EMAIL_NOT_CONFIGURED": "Forwarding emails to your inbox is currently disabled on this installation. To use this feature, it must be enabled by your administrator. Please get in touch with them to proceed.",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Permiteți rezolvarea mesajelor după ce conversația a fost rezolvată",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Permiteți utilizatorilor finali să trimită mesaje chiar și după rezolvarea conversației.",
      "WHATSAPP_SECTION_SUBHEADER": "Această cheie API este utilizată pentru integrarea cu API-urile WhatsApp.",
      "WHATSAPP_SECTION_UPDATE_SUBHEADER": "Enter the new API key to be used for the integration with the WhatsApp APIs.",
      "WHATSAPP_SECTION_TITLE": "Cheie API",
      "WHATSAPP_SECTION_UPDATE_TITLE": "Actualizați cheia API",
      "WHATSAPP_SECTION_UPDATE_PLACEHOLDER": "Introduceți noua cheie API aici",
      "WHATSAPP_SECTION_UPDATE_BUTTON": "Actualizare",
      "WHATSAPP_EMBEDDED_SIGNUP_TITLE": "WhatsApp Embedded Signup",
      "WHATSAPP_EMBEDDED_SIGNUP_SUBHEADER": "This inbox is connected through WhatsApp embedded signup.",
      "WHATSAPP_EMBEDDED_SIGNUP_DESCRIPTION": "You can reconfigure this inbox to update your WhatsApp Business settings.",
      "WHATSAPP_RECONFIGURE_BUTTON": "Reconfigure",
      "WHATSAPP_MANUAL_TRANSFER_TITLE": "Switch to Manual Setup",
      "WHATSAPP_MANUAL_TRANSFER_SUBHEADER": "This inbox was connected through WhatsApp embedded signup, which is no longer supported. Enter the WhatsApp Cloud API credentials from your own Meta app to switch this inbox to a manual setup. Configure the webhook in your Meta app using the verification token above before switching.",
      "WHATSAPP_MANUAL_TRANSFER_PHONE_NUMBER_ID_LABEL": "Phone Number ID",
      "WHATSAPP_MANUAL_TRANSFER_BUSINESS_ACCOUNT_ID_LABEL": "ID-ul contului de companie",
      "WHATSAPP_MANUAL_TRANSFER_API_KEY_LABEL": "Cheie API",
      "WHATSAPP_MANUAL_TRANSFER_API_KEY_PLACEHOLDER": "Enter a permanent access token from your Meta app",
      "WHATSAPP_MANUAL_TRANSFER_BUTTON": "Switch to Manual Setup",
      "WHATSAPP_MANUAL_TRANSFER_SUCCESS": "Inbox switched to manual setup successfully.",
      "WHATSAPP_MANUAL_TRANSFER_ERROR": "Could not switch to manual setup. Please verify the credentials and try again.",
      "WHATSAPP_CONNECT_TITLE": "Connect to WhatsApp Business",
      "WHATSAPP_CONNECT_SUBHEADER": "Upgrade to WhatsApp embedded signup for easier management.",
      "WHATSAPP_CONNECT_DESCRIPTION": "Connect this inbox to WhatsApp Business for enhanced features and easier management.",
      "WHATSAPP_CONNECT_BUTTON": "Conectează-te",
      "WHATSAPP_CONNECT_SUCCESS": "Successfully connected to WhatsApp Business!",
      "WHATSAPP_CONNECT_ERROR": "Failed to connect to WhatsApp Business. Please try again.",
      "WHATSAPP_RECONFIGURE_SUCCESS": "Successfully reconfigured WhatsApp Business!",
      "WHATSAPP_RECONFIGURE_ERROR": "Failed to reconfigure WhatsApp Business. Please try again.",
      "WHATSAPP_APP_ID_MISSING": "WhatsApp App ID is not configured. Please contact your administrator.",
      "WHATSAPP_CONFIG_ID_MISSING": "WhatsApp Configuration ID is not configured. Please contact your administrator.",
      "WHATSAPP_LOGIN_CANCELLED": "WhatsApp login was cancelled. Please try again.",
      "WHATSAPP_WEBHOOK_TITLE": "Token de verificare Webhook",
      "WHATSAPP_WEBHOOK_SUBHEADER": "Acest simbol este utilizat pentru a verifica autenticitatea punctului final webhook.",
      "WHATSAPP_TEMPLATES_SYNC_TITLE": "Sync Templates",
      "WHATSAPP_TEMPLATES_SYNC_SUBHEADER": "Manually sync message templates from WhatsApp to update your available templates.",
      "WHATSAPP_TEMPLATES_SYNC_BUTTON": "Sync Templates",
      "WHATSAPP_TEMPLATES_SYNC_SUCCESS": "Templates sync initiated successfully. It may take a couple of minutes to update.",
      "WHATSAPP_MANUAL_MIGRATION": {
        "BANNER": {
          "TITLE": "Manual setup recommended",
          "DESCRIPTION": "This inbox connects through the shared Meta app used for embedded signup, which recent Meta restrictions have affected. To avoid similar issues in the future, we recommend reconnecting it with your own Meta app.",
          "START": "Start manual migration",
          "GUIDE": "View guide"
        },
        "DIALOG": {
          "EYEBROW": "WhatsApp manual migration",
          "TITLE": "Reconnect WhatsApp inbox",
          "CLOSE": "Închide",
          "ACTION_REQUIRED_TITLE": "Reconnect with your own Meta app",
          "ACTION_REQUIRED_DESCRIPTION": "Inboxes connected through your own Meta app are not affected by restrictions on the shared embedded signup app. This guided flow updates the WhatsApp API connection without creating a new inbox.",
          "GUIDE_LINK": "Open the manual setup guide",
          "PRESERVED_TITLE": "Preserved",
          "PRESERVED_DESCRIPTION": "Conversations, contacts, collaborators, routing, business hours, and inbox settings.",
          "UPDATED_TITLE": "Updated",
          "UPDATED_DESCRIPTION": "WABA ID, phone number ID, access token, and webhook configuration.",
          "WABA_ID": "WABA ID",
          "WABA_PLACEHOLDER": "Enter WABA ID",
          "WABA_HELP": "The WhatsApp Business Account that owns this phone number.",
          "PHONE_NUMBER_ID": "Phone Number ID",
          "PHONE_NUMBER_PLACEHOLDER": "Enter Phone Number ID",
          "PHONE_NUMBER_HELP": "Meta's unique ID for the WhatsApp number connected to this inbox.",
          "DISPLAY_PHONE_NUMBER": "Display phone number",
          "DISPLAY_PHONE_NUMBER_PLACEHOLDER": "Enter display phone number",
          "DISPLAY_PHONE_NUMBER_HELP": "The customer-facing WhatsApp number. This cannot be changed during migration.",
          "ACCESS_TOKEN": "Permanent access token or system user token",
          "ACCESS_TOKEN_PLACEHOLDER": "Paste access token",
          "TOKEN_HELP_PREFIX": "The token must include",
          "TOKEN_HELP_MIDDLE": "Adaugă",
          "TOKEN_HELP_SUFFIX": "for template sync and template management.",
          "MESSAGING_PERMISSION": "whatsapp_business_messaging.",
          "MANAGEMENT_PERMISSION": "whatsapp_business_management",
          "REVIEW_TITLE": "Review before reconnecting",
          "INBOX": "Inbox",
          "PHONE_NUMBER": "Număr de telefon",
          "NOT_ENTERED": "Not entered",
          "VERIFY_NOTICE": "Chatwoot will verify these credentials with Meta before applying any changes. If verification fails, the current configuration is left untouched.",
          "BACK": "Înapoi",
          "CANCEL": "Renunță",
          "CONTINUE": "Continue",
          "REVIEW_MIGRATION": "Review migration",
          "RECONNECT": "Reconnect WhatsApp inbox"
        },
        "STEPS": {
          "BEFORE_YOU_START": {
            "TITLE": "Before you start",
            "DESCRIPTION": "This reconnects the WhatsApp API details for this inbox. Conversations, collaborators, routing, business hours, CSAT, and bot settings will be preserved."
          },
          "BUSINESS_DETAILS": {
            "TITLE": "Business details",
            "DESCRIPTION": "Enter the WhatsApp assets from the customer Meta Business account."
          },
          "ACCESS_TOKEN": {
            "TITLE": "Access token",
            "DESCRIPTION": "Paste a permanent access token or system user token with WhatsApp permissions."
          },
          "REVIEW_MIGRATION": {
            "TITLE": "Review migration",
            "DESCRIPTION": "Confirm the connection details before reconnecting this inbox. Chatwoot will verify the token, WABA, and phone number with Meta before applying changes."
          }
        }
      },
      "WHATSAPP_CALLING_ENABLED": {
        "LABEL": "Enable voice calling",
        "DESCRIPTION": "Allow agents to start and receive WhatsApp voice calls on this inbox. Available only on embedded-signup WhatsApp Cloud channels with calling permission granted by Meta."
      },
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Actualizarea setărilor formularului pre-chat"
    },
    "HELP_CENTER": {
      "LABEL": "Asistenta",
      "PLACEHOLDER": "Selectați Centrul de ajutor",
      "SELECT_PLACEHOLDER": "Selectați Centrul de ajutor",
      "NONE": "Nimic",
      "REMOVE": "Eliminarea Centrului de ajutor",
      "SUB_TEXT": "Atașarea unui Centru de ajutor cu inboxul"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Limita de atribuire automată",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Vă rugăm să introduceți o valoare mai mare de 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Limitați numărul maxim de conversații din acest inbox care pot fi atribuite automat unui agent"
    },
    "ASSIGNMENT": {
      "TITLE": "Atribuirea conversației",
      "DESCRIPTION": "Automatically assign incoming conversations to available agents based on assignment policies",
      "ENABLE_AUTO_ASSIGNMENT": "Enable automatic conversation assignment",
      "DEFAULT_RULES_TITLE": "Default assignment rules",
      "DEFAULT_RULES_DESCRIPTION": "Using the default assignment behavior for all conversations",
      "DEFAULT_RULE_1": "Earliest created conversations first",
      "DEFAULT_RULE_2": "Round robin distribution",
      "CUSTOMIZE_WITH_POLICY": "Customize with assignment policy",
      "USING_POLICY": "Using custom assignment policy for this inbox",
      "CUSTOMIZE_POLICY": "Customize with assignment policy",
      "DELETE_POLICY": "Delete policy",
      "POLICY_LABEL": "Assignment policy",
      "ASSIGNMENT_ORDER_LABEL": "Assignment Order",
      "ASSIGNMENT_METHOD_LABEL": "Assignment Method",
      "POLICY_STATUS": {
        "ACTIVE": "Activ",
        "INACTIVE": "Inactive"
      },
      "PRIORITY": {
        "EARLIEST_CREATED": "Earliest created",
        "LONGEST_WAITING": "Longest waiting"
      },
      "METHOD": {
        "ROUND_ROBIN": "Round robin",
        "BALANCED": "Balanced assignment"
      },
      "UPGRADE_PROMPT": "Custom assignment policies are available on the Business plan",
      "UPGRADE_TO_BUSINESS": "Upgrade to Business",
      "DEFAULT_POLICY_LINKED": "Default policy linked",
      "DEFAULT_POLICY_DESCRIPTION": "Link a custom assignment policy to customize how conversations are assigned to agents in this inbox.",
      "LINK_EXISTING_POLICY": "Link existing policy",
      "CREATE_NEW_POLICY": "Create new policy",
      "NO_POLICIES": "No assignment policies found",
      "VIEW_ALL_POLICIES": "View all policies",
      "CURRENT_BEHAVIOR": "Currently using default assignment behavior:",
      "LINK_SUCCESS": "Assignment policy linked successfully",
      "LINK_ERROR": "Failed to link assignment policy"
    },
    "ASSIGNMENT_POLICY": {
      "DELETE_CONFIRM_TITLE": "Delete assignment policy?",
      "DELETE_CONFIRM_MESSAGE": "Are you sure you want to remove this assignment policy from this inbox? The inbox will revert to default assignment rules.",
      "CANCEL": "Renunță",
      "CONFIRM_DELETE": "Şterge",
      "DELETE_SUCCESS": "Assignment policy removed successfully",
      "DELETE_ERROR": "Failed to remove assignment policy"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Reautorizează",
      "SUBTITLE": "Conexiunea ta de Facebook a expirat, te rugăm să-ți reconectezi pagina de Facebook pentru a continua serviciile",
      "MESSAGE_SUCCESS": "Reconectarea cu succes",
      "MESSAGE_ERROR": "A apărut o eroare, încercați din nou"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Formularele pre-chat vă permit să capturați informații despre utilizatori înainte de a începe conversația cu dvs.",
      "SET_FIELDS": "Câmpuri de formular pre-chat",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Câmpuri",
        "LABEL": "Etichetă",
        "PLACE_HOLDER": "Înlocuitor",
        "KEY": "Cheie",
        "TYPE": "Tip",
        "REQUIRED": "Necesar"
      },
      "ENABLE": {
        "LABEL": "Activați formularul de pre chat",
        "OPTIONS": {
          "ENABLED": "Da",
          "DISABLED": "Nu"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Pre chat message",
        "PLACEHOLDER": "Acest mesaj ar fi vizibil pentru utilizatori împreună cu formularul"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Vizitatorii ar trebui să furnizeze numele și adresa lor de e-mail înainte de a începe chat-ul"
      }
    },
    "CSAT": {
      "TITLE": "Activați CSAT",
      "SUBTITLE": "Automatically trigger CSAT surveys at the end of conversations to understand how customers feel about their support experience. Track satisfaction trends and identify areas for improvement over time.",
      "DISPLAY_TYPE": {
        "LABEL": "Display type"
      },
      "MESSAGE": {
        "LABEL": "Mesaj",
        "PLACEHOLDER": "Please enter a message to show users with the form"
      },
      "BUTTON_TEXT": {
        "LABEL": "Button text",
        "PLACEHOLDER": "Please rate us"
      },
      "LANGUAGE": {
        "LABEL": "Limbă",
        "PLACEHOLDER": "Select template language"
      },
      "MESSAGE_PREVIEW": {
        "LABEL": "Message preview",
        "TOOLTIP": "This may vary slightly when rendered on WhatsApp's platform."
      },
      "TEMPLATE_STATUS": {
        "APPROVED": "Approved by WhatsApp",
        "PENDING": "Pending WhatsApp approval",
        "REJECTED": "Meta rejected the template",
        "DEFAULT": "Needs WhatsApp approval",
        "NOT_FOUND": "The template does not exist in the Meta platform."
      },
      "TEMPLATE_CREATION": {
        "SUCCESS_MESSAGE": "WhatsApp template created successfully and sent for approval",
        "ERROR_MESSAGE": "Failed to create WhatsApp template"
      },
      "TEMPLATE_UPDATE_DIALOG": {
        "TITLE": "Edit survey details",
        "DESCRIPTION": "We will delete the previous template and make a new one which will be sent again for WhatsApp approval",
        "CONFIRM": "Create new template",
        "CANCEL": "Mergeți înapoi"
      },
      "UTILITY_ANALYZER": {
        "ACTION": "Check utility fit",
        "HELPER_NOTE": "Check this message before submission to improve Utility fit. The system creates a dedicated CSAT template with buttons for reporting and submits it as Utility; Meta may still reclassify it as Marketing based on content.",
        "RESULT_LABEL": "Meta category prediction",
        "GUIDANCE_NOTE": "This is a guidance check, not a guarantee of Meta approval.",
        "SUGGESTION_LABEL": "Suggested utility-safe rewrite",
        "APPLY": "Use this rewrite",
        "ERROR_MESSAGE": "Couldn't analyze the message. Please try again.",
        "CLASSIFICATION": {
          "LIKELY_UTILITY": "Likely Utility",
          "LIKELY_MARKETING": "Likely Marketing",
          "UNCLEAR": "Needs clarification"
        }
      },
      "SURVEY_RULE": {
        "LABEL": "Survey rule",
        "DESCRIPTION_PREFIX": "Send the survey if the conversation",
        "DESCRIPTION_SUFFIX": "any of the labels",
        "OPERATOR": {
          "CONTAINS": "conține",
          "DOES_NOT_CONTAINS": "nu conține"
        },
        "SELECT_PLACEHOLDER": "select labels"
      },
      "NOTE": "Note: CSAT surveys are sent only once per conversation",
      "WHATSAPP_NOTE": "Note: When you save, the system creates a dedicated CSAT template in WhatsApp (used to capture rating and feedback in reports) and submits it as Utility for approval. Meta may still classify it as Marketing based on content. After approval, surveys are sent only once per conversation as per the survey rule.",
      "API": {
        "SUCCESS_MESSAGE": "CSAT settings updated successfully",
        "ERROR_MESSAGE": "We couldn't update CSAT settings. Please try again later."
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Setați-vă disponibilitatea",
      "SUBTITLE": "Setați-vă disponibilitatea pe widget-ul livechat",
      "WEEKLY_TITLE": "Setarea orelor săptămânale",
      "TIMEZONE_LABEL": "Selectați fusul orar",
      "UPDATE": "Actualizarea setărilor orelor de lucru",
      "TOGGLE_AVAILABILITY": "Activați disponibilitatea afacerii pentru acest inbox",
      "UNAVAILABLE_MESSAGE_LABEL": "Mesaj indisponibil pentru vizitatori",
      "TOGGLE_HELP": "Enabling business availability will show the available hours on live chat widget even if all the agents are offline. Outside available hours visitors can be warned with a message and a pre-chat form.",
      "DAY": {
        "DAY": "Zi",
        "AVAILABILITY": "Disponibilitate",
        "HOURS": "Hours",
        "ENABLE": "Activați disponibilitatea pentru această zi",
        "UNAVAILABLE": "Indisponibil",
        "VALIDATION_ERROR": "Ora de începere ar trebui să fie înainte de ora închiderii.",
        "CHOOSE": "Alege"
      },
      "ALL_DAY": "Toată ziua"
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Setarea detaliilor IMAP",
      "NOTE_TEXT": "Pentru a activa SMTP, vă rugăm să configurați IMAP.",
      "UPDATE": "Actualizarea setărilor IMAP",
      "TOGGLE_AVAILABILITY": "Activarea configurației IMAP pentru acest inbox",
      "TOGGLE_HELP": "Enabling IMAP will help the user to receive email",
      "EDIT": {
        "SUCCESS_MESSAGE": "Setările IMAP actualizate cu succes",
        "ERROR_MESSAGE": "Imposibil de actualizat setările IMAP"
      },
      "ADDRESS": {
        "LABEL": "Adresa",
        "PLACE_HOLDER": "Adresa (De exemplu: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Conectează-te",
        "PLACE_HOLDER": "Conectează-te"
      },
      "PASSWORD": {
        "LABEL": "Parola",
        "PLACE_HOLDER": "Parola"
      },
      "ENABLE_SSL": "Activare SSL",
      "AUTH_MECHANISM": "Autentificare"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Reautorizarea contului MICROSOFT"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Setarea detaliilor SMTP",
      "UPDATE": "Actualizarea setărilor SMTP",
      "TOGGLE_AVAILABILITY": "Activați configurația SMTP pentru acest inbox",
      "TOGGLE_HELP": "Activarea SMTP va ajuta utilizatorul să trimită e-mailuri",
      "EDIT": {
        "SUCCESS_MESSAGE": "Setările SMTP actualizate cu succes",
        "ERROR_MESSAGE": "Imposibil de actualizat setările SMTP"
      },
      "ADDRESS": {
        "LABEL": "Adresa",
        "PLACE_HOLDER": "Adresă (De exemplu: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Conectează-te",
        "PLACE_HOLDER": "Conectează-te"
      },
      "PASSWORD": {
        "LABEL": "Parola",
        "PLACE_HOLDER": "Parola"
      },
      "DOMAIN": {
        "LABEL": "Domeniu",
        "PLACE_HOLDER": "Domeniu"
      },
      "ENCRYPTION": "Criptare",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTL-URI",
      "OPEN_SSL_VERIFY_MODE": "Deschideți modul de verificare SSL",
      "AUTH_MECHANISM": "Autentificare"
    },
    "NOTE": "Observație: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Avatar site-ul web",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatar șters cu succes",
              "ERROR_MESSAGE": "A apărut o eroare, încercați din nou"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Nume website",
          "PLACE_HOLDER": "Introduceți numele website-ului dvs. (de exemplu: Acme Inc)",
          "ERROR": "Vă rugăm să introduceți un nume valid al site-ului web"
        },
        "WELCOME_HEADING": {
          "LABEL": "Titlu de salut",
          "PLACE_HOLDER": "Bună!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Tagline de Bun Venit",
          "PLACE_HOLDER": "Noi facem conectarea cu noi simplă. Întreabă-ne orice, sau partajează-ți feedback-ul."
        },
        "REPLY_TIME": {
          "LABEL": "Timp de răspuns",
          "IN_A_FEW_MINUTES": "În câteva minute",
          "IN_A_FEW_HOURS": "În câteva ore",
          "IN_A_DAY": "Într-o zi"
        },
        "WIDGET_COLOR_LABEL": "Culoare widget",
        "WIDGET_BUBBLE": "Bubble",
        "WIDGET_BUBBLE_POSITION_LABEL": "Position:",
        "WIDGET_BUBBLE_TYPE_LABEL": "Tip:",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Discută cu noi",
          "LABEL": "Launcher Title",
          "PLACE_HOLDER": "Discută cu noi"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Actualizați setările",
          "API": {
            "SUCCESS_MESSAGE": "Setările widget-ului actualizate cu succes",
            "ERROR_MESSAGE": "Imposibil de actualizat setările IMAP"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Previzualizați",
          "SCRIPT": "Script Messenger"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Stânga",
          "RIGHT": "Dreapta"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Standard",
          "EXPANDED_BUBBLE": "Bubble extins"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Implicit",
        "CHAT": "Chat mode"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "De obicei, răspunsurile în câteva minute",
        "IN_A_FEW_HOURS": "De obicei, răspunsurile în câteva ore",
        "IN_A_DAY": "De obicei, răspunsurile într-o zi"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Începe conversația",
        "CHAT_INPUT_PLACEHOLDER": "Scrie mesajul tău"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Suntem online",
          "OFFLINE": "Suntem plecați în acest moment"
        },
        "USER_MESSAGE": "Salut",
        "AGENT_MESSAGE": "Bună"
      },
      "BRANDING_TEXT": "Oferit de Chatwoot",
      "SCRIPT_SETTINGS": "\nwindow.chatwootSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": {
        "TITLE": "Microsoft",
        "DESCRIPTION": "Connect with Microsoft"
      },
      "GOOGLE": {
        "TITLE": "Google",
        "DESCRIPTION": "Connect with Google"
      },
      "OTHER_PROVIDERS": {
        "TITLE": "Alți furnizori",
        "DESCRIPTION": "Connect with Other Providers"
      }
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Website",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "EMAIL": "E-mail",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "Canal API",
      "INSTAGRAM": "Instagram",
      "TIKTOK": "TikTok",
      "VOICE": "Voice"
    }
  }
}
